export const FETCH_HOLIDAYS_REQUEST = "FETCH_HOLIDAYS_REQUEST";
export const DELETE_HOLIDAY_REQUEST = "DELETE_HOLIDAY_REQUEST";
export const CREATE_HOLIDAY_REQUEST = "CREATE_HOLIDAY_REQUEST";
